import dayjs from 'dayjs';
import { UiVaultConfig } from '../../@types/vaults';

const getFeeChangeMessageDateSegment = (
	feeChange: UiVaultConfig['feeChanges'][number]
) => {
	return `on ${dayjs(feeChange.changeDateTs).format('MMM D, YYYY')}.`;
};

const getFeeChangeMessage = (
	performanceFeeChange: UiVaultConfig['feeChanges'][number]
) => {
	const isIncreasing =
		performanceFeeChange.newValue > performanceFeeChange.oldValue;
	const isInFuture = performanceFeeChange.changeDateTs > dayjs().unix();

	return `The ${
		performanceFeeChange.type === 'managerFee' ? 'management' : 'performance'
	} fee for this vault ${
		isIncreasing
			? isInFuture
				? 'will increase'
				: 'increased'
			: isInFuture
				? 'will decrease'
				: 'decreased'
	} from ${performanceFeeChange.oldValue}% to ${
		performanceFeeChange.newValue
	}% ${getFeeChangeMessageDateSegment(performanceFeeChange)}`;
};

export const FeeChangeMessageContent = (props: {
	vaultConfig: UiVaultConfig;
}) => {
	const relevantFeeChanges = props.vaultConfig.feeChangesToAlert;

	if (relevantFeeChanges.length === 0) {
		return null;
	}

	const feeChangeDetailSegments = relevantFeeChanges.map((feeChange) =>
		getFeeChangeMessage(feeChange)
	);

	const feeChangeEndSegment =
		'Any earnings prior to the fee change will be unaffected.';

	const multipleFeeChanges = relevantFeeChanges.length > 1;

	return (
		<div className="flex flex-col">
			{feeChangeDetailSegments.map((segment) => (
				<div key={segment}>
					{segment}
					{multipleFeeChanges ? null : ` ${feeChangeEndSegment}`}
				</div>
			))}
			{multipleFeeChanges ? (
				<div className="text-text-default">{feeChangeEndSegment}</div>
			) : null}
		</div>
	);
};
